export default {
  templates: [],
  pagination: {},
  template: null,
  blocks: [],
  selectedBlockId: null,
  loading: false,
  saving: false,
  dirty: false,
  groups: [],
  tags: []
}
